import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';

// constrain number of images to load at once
const LOAD_BATCH = 3;
export default class HotelGallery extends PureComponent {
  static makeBackground = (src) => ({
    backgroundImage: `url(${src})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50%',
    height: '300px',
  });

  constructor(props) {
    super(props);

    this.state = {
      selectedItem: 0,
    };
    this.maxItemsToShow = LOAD_BATCH;

    this.handleChangeCarousel = this.handleChangeCarousel.bind(this);
  }

  handleChangeCarousel(selectedItem) {
    const { images } = this.props;
    this.maxItemsToShow = Math.max(
      this.maxItemsToShow,
      Math.min(selectedItem + LOAD_BATCH, images.length),
    );
    this.setState({ selectedItem });
  }

  render() {
    const { selectedItem } = this.state;
    const { images, isMobile } = this.props;
    const { maxItemsToShow } = this;
    const allLoaded = maxItemsToShow === images.length;
    return (
      <Carousel
        className="lt-carousel"
        showArrows={!isMobile}
        emulateTouch
        showStatus={false}
        showIndicators={false}
        showThumbs={false}
        onChange={this.handleChangeCarousel}
        infiniteLoop={allLoaded}
        selectedItem={selectedItem}
      >
        {images.slice(0, maxItemsToShow).map((imgSrc) => (
          <div key={imgSrc} style={HotelGallery.makeBackground(imgSrc)} />
        ))}
      </Carousel>
    );
  }
}

HotelGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  isMobile: PropTypes.bool.isRequired,
};
